import "./ListGroupItem.html";
import "./ListGroupItem.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ListGroupItemComponentController } from "./ListGroupItemComponentController";

export class ListGroupItemComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: { [slot: string]: string };

    constructor() {
        // tslint:disable:object-literal-sort-keys
        this.bindings = {
            icon: "<?",
            iconClass: "<?",
            iconTitle: "<?",
            iconAppend: "<?",

            itemHeading: "<?",
            itemText: "<?",
            itemSecondaryText: "<?",
            itemClass: "<?",

            isActive: "<?",
            isExpandable: "<?",
            isExpanded: "=?",

            primaryClick: "&?",
            primaryHref: "<?",

            secondaryIcon: "<?",
            secondaryText: "<?",
            secondaryClick: "&?",
            secondaryActionResponse: "<?",
            secondaryTooltip: "<?",
            isSecondaryTooltipVisible: "<?",
            isSecondaryClickDisabled: "<?",

            actionsPermission: "<?",
            secondaryActionsPermission: "<?",
        };
        // tslint:enable
        this.controller = ListGroupItemComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/ListGroup/ListGroupItem.html";

        this.transclude = {
            adjacentText: "?lgAdjacentText",
            content: "?lgContent",
            heading: "?lgHeading",
            secondaryText: "?lgSecondaryText",
            text: "?lgText",
        };
    }
}
